export const REG_BLOCK_REASONS = {
  NEED_MANUAL_VERIFICATION: 'need_manual_verification',
  NEED_LOGIN_ORIGIN_ACC: 'need_login_to_origin_account',
  NEED_DNI_CONFIRM: 'need_dni_confirmation',
  NEED_SELECT_PHONE_NUMBER: 'need_select_phone_number',
};

export const AUTH_FLOWS = {
  REG: 'registration',
  LOGIN: 'login',
};
